import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersWeeklyReportsPostsRateCalendarsIndexResponseType,
  ApiManagersWeeklyReportsPostsRateCalendarsIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersWeeklyReportsPostsRateCalendarsIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiManagersWeeklyReportsPostsRateCalendarsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersWeeklyReportsPostsRateCalendarsIndexResponseType>(
      "/api/managers/weekly_reports/posts_rate_calendars",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersWeeklyReportsPostsRateCalendarsIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersWeeklyReportsPostsRateCalendarsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersWeeklyReportsPostsRateCalendarsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersWeeklyReportsPostsRateCalendarsIndex", params],
    queryFn: () => request({ params }),
  });
};
